import $ from 'jquery';
import 'slick-carousel';

// main page script
const slide = {
	media: () => {
		const slide = $('.media_slide_wrap');
		const progressbar = $('.progress-bar');
		const slideBtn = $('.play.pause');
		const current = $('.current');
		const total = $('.total');
		// Slick 슬라이더 초기화
		slide
			.on('init', function (event, slick) {
				// 초기 활성 슬라이드의 버튼에 애니메이션 추가
				$(slick.$slides[0]).find('.more_btn').addClass('animate');
				total.text(slick.slideCount); // 총 슬라이드 수
				current.text(slick.currentSlide + 1); // 현재 슬라이드 (1부터 시작)
			})
			.slick({
				autoplay: true,
				autoplaySpeed: 5000,
			});

		// 슬라이드 전환 후 애니메이션 처리
		slide.on('afterChange', function (event, slick, currentSlide) {
			// 모든 버튼에서 애니메이션 제거
			slide.find('.more_btn').removeClass('animate');
			// 현재 슬라이드의 버튼에 애니메이션 추가
			$(slick.$slides[currentSlide]).find('.more_btn').addClass('animate');
			progressbar.addClass('pro-ani');
		});

		slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			progressbar.removeClass('pro-ani');
			current.text(nextSlide + 1); // 다음 슬라이드 번호 (1부터 시작)
		});

		slideBtn.on('click', function () {
			if (slideBtn.hasClass('pause')) {
				// 슬라이드를 멈춤
				progressbar.removeClass('pro-ani');
				slide.slick('slickPause');
				slideBtn.removeClass('pause');
				slideBtn.text('Play');
			} else {
				// 슬라이드를 재생
				progressbar.addClass('pro-ani');
				slide.slick('slickPlay');
				slideBtn.addClass('pause');
				slideBtn.text('Pause');
			}
		});
	},
	copper: () => {
		$('.copper_slide').each(function () {
			const copper = $(this);
			// console.log(copper);
			let option = {
				// autoplay: true,
				// autoplaySpeed: 5000,
				infinite: false,
				dots: true,
				appendDots: copper.closest('.copper_slide_wrap').find('.copper_dots'),
				customPaging: function (slider, i) {
					return `<button>${i + 1}</button>`;
				},
				prevArrow: copper.closest('.copper_slide_wrap').find('.copper_btn_prev'),
				nextArrow: copper.closest('.copper_slide_wrap').find('.copper_btn_next'),
			};
			if (copper.hasClass('green-slide-two')) {
				option.slidesToShow = 2;
				option.slidesToScroll = 1;
				option.responsive = [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
						},
					},
				];
			}
			copper.slick(option);

			// 그린암모니아 수출
			if (copper.hasClass('green-export')) {
				copper.on('afterChange', function (event, slick, currentSlide) {
					console.log(currentSlide);
					const target = $('.green-ammonia-export');
					if (currentSlide === 0) {
						target.removeClass('others');
					} else {
						target.addClass('others');
					}
				});
			}
		});

		// troika copper graph slide
		const copperGraph = $('.copper_graph_slide');
		copperGraph.slick({
			autoplay: true,
			autoplaySpeed: 3000,
			dots: true,
			appendDots: $('.copper_graph_dots'),
			customPaging: function (slider, i) {
				return `<button>${i + 1}</button>`;
			},
			prevArrow: false,
			nextArrow: false,
			fade: true,
		});
	},
	contribution: () => {
		$('.society_slide_wrap').each(function () {
			const slide = $(this);
			slide.slick({
				infinite: false,
				dots: true,
				appendDots: slide.closest('.society_slide_container').find('.society_slide_dots'),
				customPaging: function (slider, i) {
					return `<button>${i + 1}</button>`;
				},
				adaptiveHeight: true
			});
		});
	},
	history: () => {
		$('.history_slide').each(function () {
			const slide = $(this);
			const wrapper = slide.closest('.history_slide_wrap');

			slide.slick({
				slidesToScroll: 1,
				infinite: false,
				dots: true,
				slidesToShow: 3,
				appendDots: slide.closest('.history_slide_wrap').find('.copper_dots'),
				customPaging: function (slider, i) {
					return `<button>${i + 1}</button>`;
				},
				prevArrow: slide.closest('.history_slide_wrap').find('.copper_btn_prev'),
				nextArrow: slide.closest('.history_slide_wrap').find('.copper_btn_next'),
				adaptiveHeight: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1.5,
						}
					}
				]
			})
		});
	},
	journalLog: () => {
		$('.journal-log_slide_wrap').each(function () {
			const slide = $(this);
			slide.slick({
				infinite: false,
				dots: true,
				appendDots: slide.closest('.journal-log_slide_container').find('.journal-log_slide_dots'),
				customPaging: function (slider, i) {
					return `<button>${i + 1}</button>`;
				},
				adaptiveHeight: true,
				variableWidth: false,
				slidesToShow: 3, 
				slidesToScroll: 3,
				centerMode: false, 
				alignItems: "flex-start", 
				flexStart: true, 
				responsive: [
					{
						breakpoint: 769,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							centerMode: false,
							alignItems: "flex-start",
							flexStart: true,
						}
					}
				]
			});
		});
	},

	init: () => {
		slide.media();
		slide.copper();
		slide.contribution();
		slide.history();
		slide.journalLog();
	},

};

export { slide };